<template>
  <div id="home-nav" class="navbar-fixed">
    <nav class="z-depth-0" style="background-color: #FED131 !important;">
      <div class="nav-wrapper container">
        <a href="#home" class="brand-logo navbar__title hide-on-small-only"></a>
        <a href="#" data-target="menu-responsive" class="sidenav-trigger">
          <i class="material-icons" style="color: #5b5b5b">menu</i>
        </a>
        
        <ul class="right hide-on-med-and-down">
          <li><a href="#home" class="menu-link">Inicio</a></li>
          <li><a href="#about" class="menu-link">Sobre mí</a></li>
          <li><a href="#projects" class="menu-link">Proyectos</a></li>
          <li><a href="#contact" class="menu-link">Contactos</a></li>
        </ul>
      </div>
    </nav>

    <ul class="sidenav" id="menu-responsive" style="background-color: #FED131">
      <li class="center-align" style="padding: 20px 0;">
        <span class="navbar__title"></span>
      </li>
      <li><div class="divider"></div></li>
      <li><a href="#home" class="sidenav-close"><i class="material-icons">home</i>Inicio</a></li>
      <li><a href="#about" class="sidenav-close"><i class="material-icons">person</i>Sobre mí</a></li>
      <li><a href="#projects" class="sidenav-close"><i class="material-icons">work</i>Proyectos</a></li>
      <li><a href="#contact" class="sidenav-close"><i class="material-icons">email</i>Contactos</a></li>
    </ul>
  </div>

  <div id="home" class="background__image section scrollspy">
    <div class="home-overlay">
      <div class="container">
        <div class="row flex-center">
          <div class="col m5 s12 center-align animate-fade-in">
            <div class="profile-container">
              <img
                class="circle responsive-img profile-pic z-depth-3"
                src="/./img/recursos/profile_picture.gif"
                alt="Cristhian Vera"
              />
            </div>
          </div>
          
          <div class="col m7 s12 left-align-desktop center-align-mobile">
            <h4 class="home__title">¡Hola! 👋</h4>
            <h1 class="home__tittle_name">Soy Cristhian Vera Almeida</h1>
            <div class="typewrite-container">
              <h5
                class="home__tittle_cargo typewrite"
                data-period="2000"
                data-type='[
                  "Software Engineer Fullstack", 
                  "Arquitecto de Apps con NestJS", 
                  "Experiencia en Flutter & Dart", 
                  "Experto en Angular & React", 
                  "Soluciones Escalables y Modernas"
                ]'
              >
                <span class="wrap"></span>
              </h5>
            </div>
            <div class="action-buttons" style="margin-top: 30px;">
              <a href="#projects" class="btn-large waves-effect waves-light btn-hero-primary">Ver Proyectos</a>
              <a href="#contact" class="btn-large waves-effect waves-light btn-hero-secondary">Contactar</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.initMaterialize();
    this.initTypewriter();
  },
  methods: {
    initMaterialize() {
      // Inicializar ScrollSpy para que los enlaces del Nav funcionen
      const spyElems = document.querySelectorAll('.scrollspy');
      if (typeof M !== 'undefined') {
        M.ScrollSpy.init(spyElems, { scrollOffset: 64 });
        
        // Inicializar Sidenav para móvil
        const sideElems = document.querySelectorAll('.sidenav');
        M.Sidenav.init(sideElems);
      }
    },
    initTypewriter() {
      const elements = document.getElementsByClassName("typewrite");
      for (let i = 0; i < elements.length; i++) {
        const toRotate = elements[i].getAttribute("data-type");
        const period = elements[i].getAttribute("data-period");
        if (toRotate) {
          new TxtType(elements[i], JSON.parse(toRotate), period);
        }
      }
    }
  }
};

// Lógica Typewriter
function TxtType(el, toRotate, period) {
  this.toRotate = toRotate;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = "";
  this.tick();
  this.isDeleting = false;
}

TxtType.prototype.tick = function () {
  const i = this.loopNum % this.toRotate.length;
  const fullTxt = this.toRotate[i];
  this.txt = this.isDeleting ? fullTxt.substring(0, this.txt.length - 1) : fullTxt.substring(0, this.txt.length + 1);
  this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";
  const that = this;
  let delta = 150 - Math.random() * 100;
  if (this.isDeleting) delta /= 2;
  if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period;
    this.isDeleting = true;
  } else if (this.isDeleting && this.txt === "") {
    this.isDeleting = false;
    this.loopNum++;
    delta = 500;
  }
  setTimeout(() => that.tick(), delta);
};
</script>

<style scoped>
/* Configuración Nav Fijo Amarillo */
.navbar-fixed nav {
  background-color: #FED131 !important;
}

.menu-link {
  color: #5b5b5b !important;
  font-weight: 700;
  font-size: 1.1rem;
  transition: 0.3s;
  text-transform: uppercase;
}

.menu-link:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

/* Hero Section */
.flex-center { display: flex; align-items: center; flex-wrap: wrap; }

.home-overlay {
  background-color: rgba(254, 206, 1, 0.7);
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.background__image {
  /* Combinamos gradiente de color encima + imagen de patrones debajo */
  background: 
    /* Esta capa va ENCIMA (Gradiente amarillo con 80% opacidad) */
    linear-gradient(
      rgba(254, 206, 1, 0.4), 
      rgba(254, 206, 1, 0.4)
    ),
    /* Esta capa va DEBAJO (Tu imagen de patrones original) */
    url("/./img/recursos/fondo_header_dowhile_.png");

  width: 100%;
  height: 100vh;
  /* Eliminamos el background-color separado, ya está en el gradiente */
  
  /* Mantener estas propiedades de centrado y ajuste */
  background-size: cover;
  background-position: center;
  
  /* Propiedades de alineación de Materialize */
  align-content: center;
  text-align: center;
}

/* Tipografía */
.navbar__title::before { content: "<PORTA"; color: #5b5b5b; font-weight: 800; font-size: 25px; }
.navbar__title::after { content: "FOLIO/>"; color: #ffffff; font-weight: 800; font-size: 25px; }

.home__title { color: #5b5b5b; font-weight: 700; margin-bottom: 0; }

.home__tittle_name {
  color: #ffffff;
  font-size: 3.5rem;
  font-weight: 800;
  margin: 10px 0 20px 0;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}

.home__tittle_cargo { color: #5b5b5b; font-weight: 500; min-height: 1.5em; }

/* Botones y Perfil */
.profile-pic { border: 8px solid white; max-width: 85%; }

.typewrite > .wrap { border-right: 0.08em solid #5b5b5b; padding-right: 5px; }

.btn-hero-primary {
  background-color: #5b5b5b;
  border-radius: 50px;
  text-transform: none;
  font-weight: 700;
  margin-right: 15px;
}

.btn-hero-secondary {
  background-color: transparent;
  border: 2px solid #5b5b5b;
  border-radius: 50px;
  text-transform: none;
  font-weight: 700;
  color: #5b5b5b;
}

@media only screen and (max-width: 992px) {
  .left-align-desktop { text-align: center; }
  .home__tittle_name { font-size: 2.5rem; }
  .btn-hero-primary, .btn-hero-secondary { margin: 10px auto; display: block; max-width: 250px; }
}
</style>